function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "prefix__a",
  d: "M4.081.128C3.406.142 2.553.79 2.365 2.084c-.179-.48-.514-1.006-.977-1.273C.956.563.383.851.264 1.33c-.093.373.16.917.347 1.24.513.886 1.405 1.519 2.288 1.99.36-1.296 1.407-1.43 1.889-2.722C5.206.714 4.752.14 4.124.128h-.043z"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__c",
  d: "M2.265 1.433c-.16.316-.183.477-.233.74-.047-.173-.213-.533-.296-.708-.147-.313-.375-.614-.691-.773C.667.503.247.651.095 1.08c-.49 1.388 1.023 2.685 2.245 3.592.213-.905 1.383-1.47 1.863-1.95 1.591-1.592.453-2.5.144-2.596-.152-.047-.295-.069-.43-.069-.908 0-1.438.956-1.652 1.376"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__f",
  d: "M4.541 2.67C2.687-.575-2.056.884 1.02 3.553c1.134.985 3.15 1.108 3.682 2.587C6.65 5.108 7.008 1.557 6.302.623 6.082.318 5.838.18 5.601.18c-.641 0-1.22 1.015-1.06 2.49"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__i",
  d: "M.876.479c-.703.553-1.123 3.247.118 4.387.678-.99 2.192-.692 3.221-1.2C7.005 2.288 3.778.293 1.783 2.33c.436-1.144.13-2.058-.423-2.058-.147 0-.312.064-.484.206"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__k",
  d: "M1.857 1.865C1.746.32.604-.39.147.568c-.406.799.331 3.059 2.064 3.928.393-.99 1.695-1.349 2.413-2.244C5.712.897 4.941.02 3.925.02c-.803 0-1.758.55-2.068 1.846"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__n",
  d: "M.301.595c-.895 1.596.755 4.207 2.178 5.898.42-1.196 2.317-1.095 3.795-2.778.584-.665.829-1.258.835-1.747V1.93C7.086.128 3.77-.198 2.382 2.69 2.622 1.064 1.87.04 1.134.04.83.041.529.216.301.595"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__q",
  d: "M4.684 2.848C2.21.259-1.87 2.714 1.61 4.485c1.285.653 3.188.302 4.027 1.556 1.576-1.416 1.086-4.8.212-5.506-.217-.183-.425-.267-.612-.267-.689 0-1.084 1.14-.553 2.58"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__s",
  d: "M.785 5.225c.599-.379.785-.13 2.018-.031 1.043.083 2.458-.496 2.458-1.705-.046-1.225-1.8-1.36-2.877-.282C3.246 1.113 2.136.242 1.42.242-.2.32-.048 3.182.785 5.225"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__v",
  d: "M3.383.521l-.024.036C1.029 4.296.407 9.121.346 13.876c.895.12 1.558.096 2.21 0-.22-1.853-.243-3.095-.25-4.672-.003-.457.038-.947.064-1.405.08-1.37.358-2.782.789-4.084.184-.559.317-.9.428-1.193.286-.755.648-1.445 1.073-2.13C4.417.334 4.153.26 3.918.26c-.217 0-.41.063-.535.26"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__d",
  x1: "49.731%",
  x2: "49.731%",
  y1: "-1.72%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#DA3F33"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#C03629"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__g",
  x1: "68.817%",
  x2: "50%",
  y1: "19.1%",
  y2: "75.375%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#C9392D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#A5281D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__l",
  x1: "50%",
  x2: "50%",
  y1: "27.468%",
  y2: "144.369%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#E04639"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#A5281D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__o",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#E04235"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#CA392D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__t",
  x1: "50.964%",
  x2: "50%",
  y1: "2.021%",
  y2: "97.979%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#C8382C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#A72A1E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__w",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#636365"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#9E9FA2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__x",
  x1: "50%",
  x2: "50%",
  y1: "25.416%",
  y2: "88.365%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#939598"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#59595C"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(12 10.8) translate(8.142 .26)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "prefix__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#E04235",
  d: "M4.081.128C3.406.142 2.553.79 2.365 2.084c-.179-.48-.514-1.006-.977-1.273C.956.563.383.851.264 1.33c-.093.373.16.917.347 1.24.513.886 1.405 1.519 2.288 1.99.36-1.296 1.407-1.43 1.889-2.722C5.206.714 4.752.14 4.124.128h-.043z",
  mask: "url(#prefix__b)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(12 10.8) translate(0 9.952)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "prefix__e",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__c"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#prefix__d)",
  d: "M2.032 2.174C1.985 2 1.82 1.64 1.736 1.465c-.147-.313-.375-.614-.691-.773C.667.503.247.651.095 1.08c-.49 1.388 1.023 2.685 2.245 3.592.213-.905 1.383-1.47 1.863-1.95 1.591-1.592.453-2.5.144-2.596-.152-.047-.295-.069-.43-.069-.908 0-1.438.956-1.652 1.376-.16.316-.183.477-.233.74z",
  mask: "url(#prefix__e)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(12 10.8) translate(4.652 12.278)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "prefix__h",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__f"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#prefix__g)",
  d: "M4.541 2.67C2.687-.575-2.056.884 1.02 3.553c1.134.985 3.15 1.108 3.682 2.587C6.65 5.108 7.008 1.557 6.302.623 6.082.318 5.838.18 5.601.18c-.641 0-1.22 1.015-1.06 2.49",
  mask: "url(#prefix__h)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(12 10.8) translate(13.182 2.586)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "prefix__j",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__i"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#E04235",
  d: "M.876.479c-.703.553-1.123 3.247.118 4.387.678-.99 2.192-.692 3.221-1.2C7.005 2.288 3.778.293 1.783 2.33c.436-1.144.13-2.058-.423-2.058-.147 0-.312.064-.484.206",
  mask: "url(#prefix__j)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(12 10.8) translate(10.855 8.401)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "prefix__m",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__k"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#prefix__l)",
  d: "M1.857 1.865C1.746.32.604-.39.147.568c-.406.799.331 3.059 2.064 3.928.393-.99 1.695-1.349 2.413-2.244C5.712.897 4.941.02 3.925.02c-.803 0-1.758.55-2.068 1.846",
  mask: "url(#prefix__m)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(12 10.8) translate(17.834 6.85)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "prefix__p",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__n"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#prefix__o)",
  d: "M.301.595c-.895 1.596.755 4.207 2.178 5.898.42-1.196 2.317-1.095 3.795-2.778.584-.665.829-1.258.835-1.747V1.93C7.086.128 3.77-.198 2.382 2.69 2.622 1.064 1.87.04 1.134.04.83.041.529.216.301.595",
  mask: "url(#prefix__p)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(12 10.8) translate(3.102 4.524)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "prefix__r",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__q"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#E04235",
  d: "M4.684 2.848C2.21.259-1.87 2.714 1.61 4.485c1.285.653 3.188.302 4.027 1.556 1.576-1.416 1.086-4.8.212-5.506-.217-.183-.425-.267-.612-.267-.689 0-1.084 1.14-.553 2.58",
  mask: "url(#prefix__r)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(12 10.8) translate(15.12 11.89)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "prefix__u",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__s"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#prefix__t)",
  d: "M.785 5.225c.599-.379.785-.13 2.018-.031 1.043.083 2.458-.496 2.458-1.705-.046-1.225-1.8-1.36-2.877-.282C3.246 1.113 2.136.242 1.42.242-.2.32-.048 3.182.785 5.225",
  mask: "url(#prefix__u)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(12 10.8) translate(9.692 14.992)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "prefix__y",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__v"
})), /*#__PURE__*/React.createElement("use", {
  fill: "url(#prefix__w)",
  xlinkHref: "#prefix__v"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#prefix__x)",
  d: "M3.383.521l-.024.036C1.029 4.296.407 9.121.346 13.876c.895.12 1.558.096 2.21 0-.22-1.853-.243-3.095-.25-4.672-.003-.457.038-.947.064-1.405.08-1.37.358-2.782.789-4.084.184-.559.317-.9.428-1.193.286-.755.648-1.445 1.073-2.13C4.417.334 4.153.26 3.918.26c-.217 0-.41.063-.535.26",
  mask: "url(#prefix__y)"
})));

function SvgInterparkOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterparkOn);
export default __webpack_public_path__ + "static/media/interpark-on.e45fa303.svg";
export { ForwardRef as ReactComponent };